module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "vue-js-switch",
    class: {
      toggled: _vm.toggled, disabled: _vm.disabled
    }
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  }), _vm._v(" "), (_vm.labels) ? _c('div', [(_vm.toggled) ? _c('span', {
    staticClass: "v-switch-label v-left"
  }, [_vm._v(_vm._s(_vm.labelChecked))]) : _c('span', {
    staticClass: "v-switch-label v-right"
  }, [_vm._v(_vm._s(_vm.labelUnchecked))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34b67adc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/ToggleButton.vue
// module id = 202
// module chunks = 1 2 3 4 5 25 29 30 31 32 66 67